import { createContext } from "react";

interface ITabStore {
    selectIndex?: number;
    setSelectIndex?: (index: number) => void;
}
export const TabStore = createContext<ITabStore>({});